import { ContentItem } from '@kentico/kontent-delivery';
import get from 'lodash/get';

import { ITwoColorSectionWithImageProps } from '../components/two-color-section-with-image/two-color-section-with-image';
import { ButtonModel } from './button-model';
import { IButtonProps } from '../components/button/button';
import { TextModel } from './text-model';
import { ITextProps } from '../components/text/text';

export class TwoColorSectionWithImageModel extends ContentItem {
  get button(): IButtonProps[] {
    const button = get(this._config, 'elements.button.value', []);
    const modeledButton = button.map((button: IButton) =>
      ButtonModel.create(button)
    );
    return modeledButton;
  }

  get image(): {
    url: string;
    description: string;
  } {
    return get(this._config, 'elements.image.value[0]', {});
  }

  get header(): ITextProps[] {
    const items = get(this._config, 'elements.header.value', []);
    const modeledTexts = items.map((article: IText) =>
      TextModel.create(article as IText)
    );
    return modeledTexts;
  }

  get description(): string {
    return get(this._config, 'elements.description_value.value', '');
  }

  get additionalMarginInColumn(): string {
    return get(
      this._config,
      'elements.additional_margin_in_column__margin.value[0].codename',
      ''
    );
  }

  public static create(
    data: ITwoColorSectionWithImage
  ): ITwoColorSectionWithImageProps {
    const {
      button,
      image,
      header,
      description,
      additionalMarginInColumn
    } = new TwoColorSectionWithImageModel(data);
    return {
      button,
      image,
      header,
      description,
      additionalMarginInColumn
    };
  }
}
